import { AgropilotRole } from '../enums/agropilot-role.enum'
import { AgropilotFeature } from '../enums/agropilot-feature.enum'

export const AGROPILOT_PERMISSIONS_MAPPING: any = {
  [AgropilotRole.SUPPLY_MANAGER]: {
    [AgropilotFeature.OFFER]: 'write',
    [AgropilotFeature.PRIORITIZATION]: 'write',
    [AgropilotFeature.PLANNING]: 'write',
    [AgropilotFeature.MONITORING]: 'write',
    [AgropilotFeature.STOCK_TRACKING]: 'write',
    [AgropilotFeature.PLANT_ARRIVAL]: 'write',
    [AgropilotFeature.ADMIN]: 'write',
  },
  [AgropilotRole.PC_RADIO]: {
    [AgropilotFeature.OFFER]: 'read',
    [AgropilotFeature.PRIORITIZATION]: 'read',
    [AgropilotFeature.PLANNING]: 'write',
    [AgropilotFeature.MONITORING]: 'write',
    [AgropilotFeature.STOCK_TRACKING]: 'write',
    [AgropilotFeature.PLANT_ARRIVAL]: 'read',
  },
  [AgropilotRole.TECHNICIAN]: {
    [AgropilotFeature.OFFER]: 'write',
    [AgropilotFeature.PRIORITIZATION]: 'read',
    [AgropilotFeature.PLANNING]: 'read',
    [AgropilotFeature.MONITORING]: 'read',
    [AgropilotFeature.STOCK_TRACKING]: 'read',
    [AgropilotFeature.PLANT_ARRIVAL]: 'read',
  },
  // Entreprise de récolte
  [AgropilotRole.SITE_MANAGER]: {
    [AgropilotFeature.MONITORING]: 'read',
  },
  [AgropilotRole.RECEPTION_CENTER]: {
    [AgropilotFeature.MONITORING]: 'write',
    [AgropilotFeature.STOCK_TRACKING]: 'write',
    [AgropilotFeature.PLANT_ARRIVAL]: 'read',
  },
  [AgropilotRole.FACTORY]: {
    [AgropilotFeature.STOCK_TRACKING]: 'read',
    [AgropilotFeature.PLANT_ARRIVAL]: 'read',
  },
}

export const AgropilotRoleHasFeatureAccess = (
  role: AgropilotRole | null | undefined,
  feature: AgropilotFeature,
  access: 'read' | 'write',
) => {
  if (role !== null && role !== undefined && AGROPILOT_PERMISSIONS_MAPPING?.[role]) {
    if (AGROPILOT_PERMISSIONS_MAPPING[role]?.[feature]) {
      return (
        AGROPILOT_PERMISSIONS_MAPPING[role][feature] == access ||
        AGROPILOT_PERMISSIONS_MAPPING[role][feature] == 'write'
      )
    }
  }

  return false
}
